import moment from "moment";
import React from "react";

const LANGUAGE_LABELS = {
  ru: "Рус",
  kz: "Қаз",
  en: "Eng",
  uk: "Укр",
};

const CATEGORY_LABELS = {
  politics: "Политика",
  business: "Бизнес",
  sports: "Спорт",
  society: "Общество",
};

const getSource = (url) => {
  if (!url) return "";
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return "";
  }
};

const isEmpty = (value) =>
  value === null || value === undefined || value === "None" || value === "";

export default function NewsCard({
  title,
  content,
  summary,
  url,
  image,
  publishDate,
  author,
  language,
  category,
}) {
  const source = getSource(url);
  const snippet = !isEmpty(summary) ? summary : content;
  const tags = [
    category && (CATEGORY_LABELS[category] || category),
    language && (LANGUAGE_LABELS[language] || language.toUpperCase()),
  ].filter(Boolean);

  return (
    <div className="worldnews_card">
      {!isEmpty(image) && (
        <div className="worldnews_card__image">
          <img
            src={image}
            alt={title}
            loading="lazy"
            onError={(e) => {
              e.target.parentNode.style.display = "none";
            }}
          />
        </div>
      )}
      <div className="worldnews_card__body">
        <div className="worldnews_card__meta">
          {publishDate && (
            <span>{moment(publishDate).format("DD.MM.YYYY HH:mm")}</span>
          )}
          {source && <span className="worldnews_card__source">{source}</span>}
        </div>
        <a
          className="worldnews_card__title"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {title}
        </a>
        {!isEmpty(snippet) && (
          <p className="worldnews_card__snippet">{snippet}</p>
        )}
        <div className="worldnews_card__footer">
          {tags.map((tag) => (
            <span key={tag} className="worldnews_card__tag">
              {tag}
            </span>
          ))}
          {!isEmpty(author) && (
            <span className="worldnews_card__author">{author}</span>
          )}
        </div>
      </div>
    </div>
  );
}
